/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from '@consts/url.const';
import { WorkflowWebhookModel } from '@models/workflow-webhook.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkflowWebhooksService {
  constructor(private http: HttpClient) {}

  public getWebhooks(
    orgId: string,
  ): Observable<WorkflowWebhookModel.WebhookEndpointMongoDocument[]> {
    return this.http.get<WorkflowWebhookModel.WebhookEndpointMongoDocument[]>(
      api.workflows.getWebhooks(orgId),
    );
  }

  public deleteWebhook(id: string): Observable<{ status: boolean }> {
    return this.http.delete<{ status: boolean }>(
      api.workflows.deleteWebhook(id),
    );
  }

  public createWebhook(
    orgId: string,
    webhook: WorkflowWebhookModel.CreateWebhookDto,
  ): Observable<WorkflowWebhookModel.WebhookEndpointMongoDocument> {
    return this.http.post<WorkflowWebhookModel.WebhookEndpointMongoDocument>(
      api.workflows.createWebhook(orgId),
      webhook,
    );
  }

  public editWebhook(
    id: string,
    webhook: WorkflowWebhookModel.UpdateWebhookDto,
  ): Observable<WorkflowWebhookModel.WebhookEndpointMongoDocument> {
    return this.http.patch<WorkflowWebhookModel.WebhookEndpointMongoDocument>(
      api.workflows.editWebhook(id),
      webhook,
    );
  }
}
